'use client';

import { c as _c } from "react/compiler-runtime";
import { useTranslations } from 'next-intl';
import { DocsLinks } from '@/components/how-it-works/docs-links';
import { Coins01Icon, JusticeScale01Icon, Rocket01Icon } from '@/components/ui/icon/glyphs';
import { InfoModal } from '@/components/ui/info-modal';
import { useWinnerInfoModalStore } from '@/stores/winner-info-modal';

/**
 * "How winners work" explainer — launched from the winner-detail header's info
 * icon. Built on the shared `InfoModal` (same shape as `MarketHowItWorksModal`)
 * so it reads consistently with every other how-it-works modal.
 */
export function WinnerInfoModal() {
  const $ = _c(41);
  const t = useTranslations("market.winnerDetail");
  const open = useWinnerInfoModalStore(_temp);
  const setOpen = useWinnerInfoModalStore(_temp2);
  let t0;
  if ($[0] !== t) {
    t0 = t("infoModalTitle");
    $[0] = t;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== t) {
    t1 = t("infoGotIt");
    $[2] = t;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== setOpen) {
    t2 = () => setOpen(false);
    $[4] = setOpen;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== t1 || $[7] !== t2) {
    t3 = <InfoModal.Footer cta={t1} onClose={t2} />;
    $[6] = t1;
    $[7] = t2;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== t) {
    t4 = t("infoStep1Title");
    $[9] = t;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== t) {
    t5 = t("infoStep1Body");
    $[11] = t;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  let t6;
  if ($[13] !== t4 || $[14] !== t5) {
    t6 = <InfoModal.IconItem icon={JusticeScale01Icon} title={t4} description={t5} />;
    $[13] = t4;
    $[14] = t5;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  let t7;
  if ($[16] !== t) {
    t7 = t("infoStep2Title");
    $[16] = t;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  let t8;
  if ($[18] !== t) {
    t8 = t("infoStep2Body");
    $[18] = t;
    $[19] = t8;
  } else {
    t8 = $[19];
  }
  let t9;
  if ($[20] !== t7 || $[21] !== t8) {
    t9 = <InfoModal.IconItem icon={Rocket01Icon} title={t7} description={t8} />;
    $[20] = t7;
    $[21] = t8;
    $[22] = t9;
  } else {
    t9 = $[22];
  }
  let t10;
  if ($[23] !== t) {
    t10 = t("infoStep3Title");
    $[23] = t;
    $[24] = t10;
  } else {
    t10 = $[24];
  }
  let t11;
  if ($[25] !== t) {
    t11 = t("infoStep3Body");
    $[25] = t;
    $[26] = t11;
  } else {
    t11 = $[26];
  }
  let t12;
  if ($[27] !== t10 || $[28] !== t11) {
    t12 = <InfoModal.IconItem icon={Coins01Icon} title={t10} description={t11} />;
    $[27] = t10;
    $[28] = t11;
    $[29] = t12;
  } else {
    t12 = $[29];
  }
  let t13;
  if ($[30] !== t12 || $[31] !== t6 || $[32] !== t9) {
    t13 = <InfoModal.IconList>{t6}{t9}{t12}</InfoModal.IconList>;
    $[30] = t12;
    $[31] = t6;
    $[32] = t9;
    $[33] = t13;
  } else {
    t13 = $[33];
  }
  let t14;
  if ($[34] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = <DocsLinks docsPath="/concepts/opinion-markets" />;
    $[34] = t14;
  } else {
    t14 = $[34];
  }
  let t15;
  if ($[35] !== open || $[36] !== setOpen || $[37] !== t0 || $[38] !== t13 || $[39] !== t3) {
    t15 = <InfoModal open={open} onOpenChange={setOpen} size="lg" title={t0} footer={t3}>{t13}{t14}</InfoModal>;
    $[35] = open;
    $[36] = setOpen;
    $[37] = t0;
    $[38] = t13;
    $[39] = t3;
    $[40] = t15;
  } else {
    t15 = $[40];
  }
  return t15;
}
function _temp2(s_0) {
  return s_0.setOpen;
}
function _temp(s) {
  return s.open;
}